










import { Component, Prop } from "vue-property-decorator";

import CopyLinkButton from "@share/common/buttons/CopyLinkButton.vue";
import PartnerActions from "../common/PartnerActions.vue";
import { TooltipDirective } from '@share/directives/Tooltip';

@Component({
    directives: {TooltipDirective},
    components: {
        CopyLinkButton
    }
})

export default class PartnerCreateActions extends PartnerActions {

    @Prop({ required: true }) isSaved: boolean;
    @Prop({ default: "" }) partnerId: string;

    get backend() {
        return this.$route.params.backend || this.$store.state.session?.backend;
    }
}

